// extracted by mini-css-extract-plugin
export default {"title-section":"ptMQTGmMyE","titleSection":"ptMQTGmMyE","table":"fq1mPLFnsz","status":"iwrqMg1_mQ"};